import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from '../profile/constants';

const lazy = {
    EditLanguagesPage: lazyLoad(async () => {
        const { EditLanguagesPage } = await import('./EditLanguages');

        return { default: EditLanguagesPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.user-profile.language-edit.headline',
        page: lazy.EditLanguagesPage,
        path: route.patterns.individualUser.languages.edit,
    },
];
